export default function releaseNameOrEmptyObject(): Record<string, never> | { release: string } {
  if (process.env.RELEASE_NAME != null)
    return {
      release: process.env.RELEASE_NAME,
    };
  return {};
}
